import { createReducer, on } from '@ngrx/store';

import { ServerConfig } from 'ish-core/models/server-config/server-config.model';

import { loadExtraConfigSuccess, loadServerConfigSuccess } from './server-config.actions';

// _config is not updated in SSR ngrx state.
// As ngrx-state-transfer filters state without '_' prefix, changed _config to config.
export interface ServerConfigState {
  config: ServerConfig;
  extra: ServerConfig;
}

const initialState: ServerConfigState = {
  config: undefined,
  extra: undefined,
};

export const serverConfigReducer = createReducer(
  initialState,
  on(
    loadServerConfigSuccess,
    (state, action): ServerConfigState => ({
      ...state,
      config: action.payload.config,
    })
  ),
  on(
    loadExtraConfigSuccess,
    (state, action): ServerConfigState => ({
      ...state,
      extra: action.payload.extra,
    })
  )
);
